import { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Redirects old /ats/public/careers/:workspaceCode/* URLs
 * to the new careers portal: https://careers.aaas.chat/{workspaceCode}/*
 */
export function CareersRedirect() {
  const { t } = useTranslation('ats');
  const { workspaceCode } = useParams<{ workspaceCode: string }>();
  const location = useLocation();

  useEffect(() => {
    if (!workspaceCode) return;

    const careersBase = import.meta.env.VITE_CAREERS_BASE_URL || 'https://careers.aaas.chat';

    // Extract the path after /careers/:workspaceCode
    const prefix = `/careers/${workspaceCode}`;
    const remainingPath = location.pathname.replace(
      new RegExp(`^(/ats/public)?${prefix}`),
      ''
    );

    window.location.href = `${careersBase}/${workspaceCode}${remainingPath}`;
  }, [workspaceCode, location.pathname]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <p className="text-gray-400 text-sm">{t('public.redirecting')}</p>
    </div>
  );
}
